import apiService from "../../../../../services/api";

export const getCreditAlerts = async () => {
  return await apiService.get(`/billing/alerts`);
};
export const createCreditAlerts = async (payload: any) => {
  return await apiService.post(`/billing/alerts`, payload);
};
export const deleteCreditAlerts = async (alertId: any) => {
  return await apiService.delete(`/billing/alerts/${alertId}`);
};
//billing/alerts/{alert_id}
///billing/alerts